import { ColumnFiltersState, SortingState } from '@tanstack/react-table';

export enum EventTableType {
  LIVE = 'Live',
  HISTORICAL = 'Historical',
}

export enum EventTableInterval {
  XXShort = '5 minutes',
  ExtraShort = '15 minutes',
  Short = '30 minutes',
  Medium = '1 hours',
  Long = '6 hours',
  Day = '1 day',
  Week = '1 week',
  Month = '1 month',
  Year = '1 year',
}

export const tableTypeValueToKey: Record<string, keyof typeof EventTableType> = Object.entries(
  EventTableType
).reduce(
  (acc, [key, value]) => {
    acc[value] = key as keyof typeof EventTableType;
    return acc;
  },
  {} as Record<string, keyof typeof EventTableType>
);
export interface EventTableConfig {
  title: string;
  rootId: string;
  type: EventTableType;
  historicalPageSize?: number;
  historyDefaultFilters: ColumnFiltersState;
  historyDefaultSorting: SortingState;
  from: string;
  to: string;
  liveDefaultFilters: ColumnFiltersState;
  liveDefaultSorting: SortingState;
  liveInterval: EventTableInterval;
  livePageSize?: number;
}
